<template>
    <HomeLayout>
        <Section
            hero-background
            fullscreen
            repeat-background
            padding-top-half
            padding-bottom-half
        >
            <Container>
                <SectionHeadline> Wählen Sie ein Fahrzeug aus </SectionHeadline>

                <div
                    class="text-center text-3xl text-red-600 font-bold mb-10"
                    v-if="$page.props.errors.vehicle_not_available"
                >
                    {{ $page.props.errors.vehicle_not_available }}
                </div>

                <div
                    v-if="vehicles.length == 0"
                    class="flex flex-col items-center justify-center"
                >
                    <div class="text-2xl text-primary-text">
                        Ihre Suche ergab keine Treffer.
                    </div>

                    <div class="mt-10 flex">
                        <Link :href="route('home')">
                            <StyledButton background-white>
                                <ArrowLeftIcon class="h-5 w-5 mr-2" /> Zurück
                                zur Eingabe
                            </StyledButton>
                        </Link>
                    </div>
                </div>

                <div class="flex flex-col space-y-14">
                    <VehicleCarTile
                        v-for="vehicle in vehicles.filter(
                            (vehicle) =>
                                vehicle.type_raw === 'car' ||
                                vehicle.type_raw === 'oldtimer'
                        )"
                        :key="vehicle.id"
                        :vehicle="vehicle"
                        :booking="booking"
                    />

                    <VehicleTruckTile
                        v-for="vehicle in vehicles.filter(
                            (vehicle) => vehicle.type_raw === 'truck'
                        )"
                        :key="vehicle.id"
                        :vehicle="vehicle"
                        :booking="booking"
                    />
                </div>
            </Container>
        </Section>
    </HomeLayout>
</template>

<script>
import HomeLayout from "@/Layouts/HomeLayout.vue";
import Section from "@/Components/Section.vue";
import SectionHeadline from "@/Components/SectionHeadline.vue";
import Container from "@/Components/Container.vue";
import { Link } from "@inertiajs/inertia-vue3";
import StyledButton from "@/Components/StyledButton.vue";
import VehicleCarTile from "@/Components/VehicleCarTile.vue";
import VehicleTruckTile from "@/Components/VehicleTruckTile.vue";
import { ArrowLeftIcon } from "@heroicons/vue/outline";

export default {
    components: {
        HomeLayout,
        Section,
        SectionHeadline,
        Container,
        StyledButton,
        Link,
        VehicleCarTile,
        VehicleTruckTile,
        ArrowLeftIcon,
    },

    props: {
        vehicles: {
            type: Object,
            required: true,
        },
        booking: {
            type: Object,
            required: true,
        },
    },
};
</script>
